import axios from "axios";
import { ErrorMessage, Field, FieldArray, Formik, FormikConsumer, FormikProps, useFormik } from "formik";
import React, { Component, useEffect, useState } from 'react';
import internal from "stream";
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { API_URL_LARAVEL } from "../config/config";
import InputField from "./shared-component/Input/InputField";

type DomandaFields = {
    nome: string,
    cognome: string,
    comunedomanda: number,
    cf: string,
    sesso: string,
    nascita: string,
    nazionenascita: string,
    comunenascita: string,
    provincianascita: string,
    cittadinanza: string,
    indirizzoresidenza: string,
    civicoresidenza: string,
    email: string,
    confermaemail: string,
    cellulare: string,
    iban: string,
    indirizzodomicilio: string,
    telefono: string,
  
    istanzadoppia: boolean,
 
    allegati: []


}

const MAX_FILE_SIZE = 2000400; //100KB

const validFileExtensions = { image: ['jpg', 'pdf', 'tif', 'png', 'jpeg'] };

const yupSchema = Yup.object().shape({
    nome: Yup.string().required('Nome è richiesto').min(2, "inserire almeno 2 caratteri"),
    cognome: Yup.string().required('Obbligatorio').min(2, "inserire almeno 2 caratteri"),
    comunedomanda: Yup.string().required('Obbligatorio'),
    cf: Yup.string().required('Obbligatorio').matches(
        /^[A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}$/,
        "Codice fiscale non conforme"
    ),
    sesso: Yup.string().required('Obbligatorio'),
    nascita: Yup.string().required('Obbligatorio'),
    nazionenascita: Yup.string().required('Obbligatorio'),
    comunenascita: Yup.string().required('Obbligatorio'),
    provincianascita: Yup.string().required('Obbligatorio'),
    cittadinanza: Yup.string().required('Obbligatorio'),


    //istanzadoppia: Yup.boolean().isTrue(),
    /*  iban: Yup.string().required('Obbligatorio').matches(
          /^(it|IT)[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/,
          "Iban non conforme"
      ), */
    indirizzoresidenza: Yup.string().required('Obbligatorio'),
    civicoresidenza: Yup.string().required('Obbligatorio'),
    email: Yup.string().email().matches(/^(?!.*@[^,]*,)/).required('Obbligatorio'),
    confermaemail: Yup.string().email().matches(/^(?!.*@[^,]*,)/).required('Obbligatorio').oneOf([Yup.ref('email'), null], "Email diversa!"),
    cellulare: Yup.string().required('Obbligatorio'),
    indirizzodomicilio: Yup.string(),
    telefono: Yup.string().required('Obbligatorio'),


    dichiara3: Yup.boolean().isTrue(),


    allegati: Yup.array().of(

        Yup.object().shape({
            fileisee: Yup
                .mixed()
                .required("Required")
                .test("is-valid-size", "Dimensione Massima 2M",
                    value => value && value.size <= MAX_FILE_SIZE)
            ,
           
            documento: Yup
                .mixed()
                .required("Required")
                .test("is-valid-size", "Dimensione Massima 2M",
                    value => value && value.size <= MAX_FILE_SIZE)
            ,
            altro: Yup
                .mixed().test("is-valid-size", "Dimensione Massima 2M",

                    (value) => {
                        if (!value) return true

                        return value && value.size <= MAX_FILE_SIZE
                    })

           })
    ),



})

const valoriIniziali: DomandaFields = {
    /*
    nome: "aaaa",
    cognome: "aaaaa",
    comunedomanda: 0,
    cf: "aaaa",
    sesso: "a",
    nascita: "2021-02-02",
    nazionenascita: "aaa",
    comunenascita: "aaa",
    provincianascita: "aa",
    cittadinanza: "a",
   
    indirizzoresidenza: "aa",
    civicoresidenza: "aaa",

    email: "aaaaa",
    confermaemail: "aaaaa",
    cellulare: "aaaa",
    telefono: "erewr",
    indirizzodomicilio:"erwrwer",
    figli:[],

    dichiara1:false,
    dichiara2:false,
    dichiara3:false,
    dichiara4:false,
    dichiara5:false,
    dichiara6:false,
    dichiara7:false,
    dichiara8:false,

//*/


    nome: "",
    cognome: "",
    comunedomanda: 0,
    cf: "",
    sesso: "",
    nascita: "",
    nazionenascita: "",
    comunenascita: "",
    provincianascita: "",
    cittadinanza: "",
    indirizzoresidenza: "",
    civicoresidenza: "",
    iban: "",
    email: "",
    confermaemail: "",
    cellulare: "",
    telefono: "",
    indirizzodomicilio: "",
 


    istanzadoppia:false,

    allegati: []
    //*/
}
const Toast = Swal.mixin({
    position: 'top-end',
    timer: 2000,
    showConfirmButton: false,
    toast: true,
})


const Domanda = () => {


    const [visual, setsetvisual] = useState(false)
    const [update, setupdate] = useState(false);
    const stampa_id = (id: any) => {
        var nw = window.open();
        var html = document.body.innerHTML + '<style> .body{ width: 200px} </style>'

        nw.document.write(document.body.innerHTML);
        //   nw.print();
        //   nw.close();
    }

    // const formik = useFormik({
    //    initialValues: valoriIniziali,
    //    validationSchema: yupSchema,
    //    validateOnBlur: false,
    //    validateOnChange:false,
    //    onSubmit:(values)=>{
    //     alert(JSON.stringify(values));
    //    }
    // })

    return (
        <> <h1> Scaduto / </h1>
           {true && <> <Formik initialValues={valoriIniziali}
                validationSchema={yupSchema}
                validateOnBlur={false}
                validateOnChange={false}

                onSubmit={(values) => {

                    const fileInput = document.querySelectorAll('input[type="file"]');

                    console.log(fileInput);
                    const data = JSON.stringify({ ...values })
                    const fd = new FormData();
                    // append directly as part of the postData in plain text
                    fd.append('istanzajson', data);
                    fd.append('identificativo', "109914");
                    fd.append('nome', "BENEFICI ECONOMICI A SOSTEGNO DELLA FAMIGLIA - Fondoannualità 2021");

                    fileInput.forEach((docItem) => {
                        fd.append(docItem.id, (document.getElementById(docItem.id) as HTMLInputElement).files[0]);
                    });


                    axios.post(API_URL_LARAVEL + '/istanza', fd, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                    ).then((response) => {

                        console.log(response);

                        if (response.data.success) {
                            Toast.fire({
                                title: response.data.text,
                                icon: 'success'
                            });


                            window.location.href = "/esito?id=" + response.data.result;


                        }
                    }).catch((err) => {
                        console.log(err);

                        alert('Errore imprevisto. Provare a rinominare i file allegati senza utilizzare caratteri speciali');

                        document.getElementById('spinner').style.display = 'none';
                        document.getElementById('_conferma').style.display = 'inline';

                    });

                    //    alert(JSON.stringify(values));
                }}>
                {(formik: FormikProps<any>) => (
                    <div className="form">
                        <div className="form-group">
                            <div className="col-sm-5 col-sm-offset-1" >
                                <table>
                                    <tbody><tr>
                                        <td>
                                            <ol className="breadcrumb" style={{ backgroundColor: 'white' }}>

                                                <li className="active">
                                                    Richiesta di ammissione al bando PER L’EROGAZIONE STRAORDINARIA DI
                                                    BENEFICI ECONOMICI A SOSTEGNO DELLA FAMIGLIA - Fondo
                                                    annualità 2021
                                                </li>
                                            </ol>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                        </div>



                        {<div id="div_domanda">
                            <br />
                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Dati Anagrafici </div></div>
                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='nome' label='Nome' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='cognome' label='Cognome' />
                                </div>
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label htmlFor='cf'>Codice Fiscale</label>
                                        <input type="text" className="form-control" name='cf' id='cf' onChange={event => formik.setFieldValue('cf', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='cf' /> </small>

                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm">
                                    <div className="form-group">
                                        <div className="select-wrapper">
                                            <label htmlFor="sesso">Sesso</label>
                                            <select id="sesso" onChange={event => formik.setFieldValue('sesso', event.target.value)}>
                                                <option selected value="">Scegli un'opzione</option>
                                                <option value="M">M</option>
                                                <option value="F">F</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label className="active" htmlFor="nascita">Data di nascita (gg/mm/aaaa)</label>
                                        <input type="date" id="nascita" name="nascita" onChange={evt => {
                                            formik.setFieldValue('nascita', evt.target.value)
                                        }} />
                                        <ErrorMessage name={`nascita`} />

                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="select-wrapper">
                                        <label htmlFor="nazionenascita">Nazione di nascita</label>
                                        <select id="nazionenascita" onChange={event => formik.setFieldValue('nazionenascita', event.target.value)} >
                                            <option selected value="">Scegli un'opzione</option>
                                            <option value={122}>ITALIA</option><option value={1}>AFGHANISTAN</option><option value={2}>ALBANIA</option><option value={3}>ALGERIA</option><option value={4}>ANDORRA</option><option value={5}>ANGOLA</option><option value={6}>ANGUILLA</option><option value={7}>ANTIGUA E BARBUDA</option><option value={8}>ANTILLE BRITANNICHE</option><option value={9}>ANTILLE OLANDESI</option><option value={10}>ARABIA SAUDITA</option><option value={11}>ARGENTINA</option><option value={12}>ARMENIA</option><option value={13}>AUSTRALIA</option><option value={14}>AUSTRIA</option><option value={15}>AZERBAIGIAN</option><option value={16}>BAHAMA</option><option value={17}>BAHREIN</option>
                                            <option value={18}>BANGLADESH</option><option value={19}>BARBADOS</option><option value={20}>BELGIO</option><option value={21}>BELIZE</option><option value={22}>BENIN</option><option value={23}>BERMUDA (ISOLE)</option><option value={24}>BHUTAN</option><option value={25}>BIELORUSSIA</option><option value={26}>BIRMANIA</option><option value={27}>BOLIVIA</option><option value={28}>BOSNIA ED ERZEGOVINA</option><option value={29}>BOTSWANA</option><option value={30}>BRASILE</option><option value={31}>BRUNEI</option><option value={32}>BULGARIA</option><option value={33}>BURKINA FASO</option><option value={34}>BURUNDI</option><option value={35}>CAMBOGIA</option><option value={36}>CAMERUN</option><option value={37}>CANADA</option><option value={38}>CAPO VERDE</option><option value={39}>CAYMAN (ISOLE)</option><option value={40}>CECOSLOVACCHIA</option><option value={41}>CENTRAFRICANA REPUBBLICA</option><option value={42}>CHRISTMAS (ISOLA)</option><option value={43}>CIAD</option><option value={44}>CILE</option><option value={45}>CINA (REPUBBLICA POPOLARE)</option><option value={46}>CIPRO</option><option value={47}>CITTA' DEL VATICANO</option><option value={48}>ISOLE COCOS (KEELING)</option><option value={49}>COLOMBIA</option><option value={50}>COMORE</option>
                                            <option value={51}>CONGO REBUBBLICA DEMOCRATICA (ZAIRE)</option><option value={52}>CONGO REPUBBLICA POPOLARE</option><option value={53}>COOK</option><option value={54}>COREA DEL NORD, REPUBBLICA DEMOCRATICA</option><option value={55}>COREA DEL SUD, REPUBBLICA DI COREA</option><option value={56}>COSTA D'AVORIO</option><option value={57}>COSTA RICA</option><option value={58}>CROAZIA</option><option value={59}>CUBA</option><option value={60}>DANIMARCA</option><option value={61}>DIPENDENZE AUSTRALIANE</option><option value={62}>DIPENDENZE BRITANNICHE</option><option value={63}>DIPENDENZE CANADESI</option><option value={64}>DIPENDENZE FRANCESI</option><option value={65}>DIPENDENZE NEOZELANDESI</option><option value={66}>DIPENDENZE NORVEGESI ANTARTICHE</option><option value={67}>DIPENDENZE NORVEGESI ARTICHE</option><option value={68}>DIPENDENZE RUSSE</option><option value={69}>DIPENDENZE STATUNITENSI</option><option value={70}>DIPENDENZE SUDAFRICANE</option><option value={71}>DOMINICA</option><option value={72}>ECUADOR</option><option value={73}>EGITTO</option><option value={74}>EL SALVADOR</option><option value={75}>EMIRATI ARABI UNITI</option><option value={76}>ERITREA</option><option value={77}>ESTONIA</option><option value={78}>ETIOPIA</option><option value={79}>FAER OER (Isole)</option><option value={80}>FIGI O VITI</option><option value={81}>FILIPPINE</option><option value={82}>FINLANDIA</option><option value={83}>FRANCIA</option><option value={84}>GABON</option><option value={85}>GAMBIA</option><option value={86}>TERRITORI PALESTINESI (GAZA)</option><option value={87}>GEORGIA</option><option value={88}>GERMANIA</option><option value={89}>GERMANIA REPUBBLICA DEMOCRATICA</option><option value={90}>GERMANIA REPUBBLICA FEDERALE</option><option value={91}>GHANA</option><option value={92}>GIAMAICA</option>
                                            <option value={93}>GIAPPONE</option><option value={94}>GIBILTERRA</option><option value={95}>GIBUTI</option><option value={96}>GIORDANIA</option><option value={97}>GRAN BRETAGNA E IRLANDA DEL NORD</option><option value={98}>GRECIA</option><option value={99}>GRENADA</option><option value={100}>GROENLANDIA</option><option value={101}>GUADALUPA</option><option value={102}>GUAM (ISOLA)</option><option value={103}>GUATEMALA</option><option value={104}>GUIANA FRANCESE</option><option value={105}>GUINEA</option><option value={106}>GUINEA BISSAU</option><option value={107}>GUINEA EQUATORIALE</option><option value={108}>GUYANA</option><option value={109}>HAITI</option><option value={110}>HONDURAS</option><option value={111}>HONG KONG</option><option value={112}>INDIA</option><option value={113}>INDONESIA</option><option value={114}>IRAN</option><option value={115}>IRAQ</option><option value={116}>IRIAN OCCIDENTALE</option><option value={117}>IRLANDA (Eire)</option><option value={118}>ISLANDA</option>
                                            <option value={119}>ISOLE CILENE (PASQUA E SALA Y GOMEZ)</option><option value={120}>ISOLE VERGINI BRITANNICHE</option><option value={121}>ISRAELE</option><option value={123}>JUGOSLAVIA</option><option value={124}>KAZAKISTAN</option><option value={125}>KENYA</option><option value={126}>KIRGHIZISTAN</option><option value={127}>KIRIBATI</option><option value={128}>KUWAIT</option><option value={129}>LA REUNION (ISOLA)</option><option value={130}>LAOS</option><option value={131}>LESOTHO</option><option value={132}>LETTONIA</option><option value={133}>LIBANO</option><option value={134}>LIBERIA</option><option value={135}>LIBIA</option><option value={136}>LIECHTENSTEIN</option><option value={137}>LITUANIA</option><option value={138}>LUSSEMBURGO</option><option value={139}>MACAO</option><option value={140}>MACEDONIA</option><option value={141}>MACQUARIE (ISOLE)</option><option value={142}>MADAGASCAR</option><option value={143}>MALAWI</option>
                                            <option value={144}>MALAYSIA</option><option value={145}>MALDIVE</option><option value={146}>MALI</option><option value={147}>MALTA</option><option value={148}>MALVINE O FALKLAND (ISOLE)</option><option value={149}>MAN (ISOLA)</option><option value={150}>MARIANNE (ISOLE)</option><option value={151}>MAROCCO</option><option value={152}>MARSHALL</option><option value={153}>MARTINICA</option><option value={154}>MAURITANIA</option><option value={155}>MAURIZIO</option><option value={156}>MAYOTTE (ISOLA)</option><option value={157}>MESSICO</option><option value={158}>MICRONESIA STATI FEDERATI</option><option value={159}>MIDWAY</option><option value={160}>MOLDAVIA</option><option value={161}>MONACO</option><option value={162}>MONGOLIA</option><option value={163}>MONTSERRAT</option><option value={164}>MOZAMBICO</option><option value={165}>NAMIBIA</option><option value={166}>NAURU</option><option value={167}>NEPAL</option><option value={168}>NICARAGUA</option><option value={169}>NIGER</option><option value={170}>NIGERIA</option><option value={171}>NIUE O SAVAGE (ISOLE)</option><option value={172}>NORFOLK (ISOLE DEL MAR DEI CORALLI)</option><option value={173}>NORMANNE (ISOLE)</option><option value={174}>NORVEGIA</option><option value={175}>NUOVA CALEDONIA (ISOLE E DIPENDENZE)</option><option value={176}>NUOVA ZELANDA</option><option value={177}>OMAN</option><option value={178}>PAESI BASSI (OLANDA)</option>
                                            <option value={179}>PAKISTAN</option><option value={180}>PALAU</option><option value={181}>PANAMA</option><option value={182}>PANAMA ZONA DEL CANALE</option><option value={183}>PAPUA NUOVA GUINEA</option><option value={184}>PARAGUAY</option><option value={185}>PERU'</option><option value={186}>PITCAIRN (E DIPENDENZE)</option><option value={187}>POLINESIA FRANCESE (ISOLE)</option><option value={188}>POLONIA</option><option value={189}>PORTOGALLO</option><option value={190}>PUERTO RICO</option><option value={191}>QATAR</option><option value={192}>REPUBBLICA CECA</option><option value={193}>REPUBBLICA DELLA GUAYANA</option><option value={194}>REPUBBLICA DOMINICANA</option><option value={195}>ROMANIA</option><option value={196}>RUANDA</option><option value={197}>RUSSIA (FEDERAZIONE RUSSA)</option><option value={198}>SAINT KITTS E NEVIS</option><option value={199}>SANTA LUCIA</option><option value={200}>SAINT PIERRE ET MIQUELON</option><option value={201}>SAINT VINCENT E GRENADINE</option><option value={202}>SALOMONE</option><option value={203}>SAMOA</option><option value={204}>SAMOA AMERICANE (ISOLE)</option><option value={205}>SAN MARINO</option><option value={206}>SANT'ELENA (ISOLA)</option><option value={207}>SAO TOME' E PRINCIPE</option><option value={208}>SEICELLE</option><option value={209}>SENEGAL</option><option value={210}>SIERRA LEONE</option><option value={211}>SINGAPORE</option><option value={212}>SIRIA</option><option value={213}>SLOVACCHIA (REPUBBLICA)</option><option value={214}>SLOVENIA</option><option value={215}>SOMALIA</option><option value={216}>SPAGNA</option><option value={217}>SRI LANKA</option><option value={218}>STATI UNITI D'AMERICA</option><option value={219}>STRANIERO</option><option value={220}>SUDAFRICANA REBUBBLICA</option><option value={221}>SUDAN</option><option value={222}>SURINAME</option><option value={223}>SVEZIA</option><option value={224}>SVIZZERA</option><option value={225}>SWAZILAND</option><option value={226}>TAGIKISTAN</option><option value={227}>TAIWAN (FORMOSA)</option><option value={228}>TANZANIA</option><option value={229}>THAILANDIA</option><option value={230}>TIMOR (ISOLA)</option><option value={231}>TOGO</option><option value={232}>TOKELAU (ISOLE DELL'UNIONE)</option><option value={233}>TONGA (ISOLE DEGLI AMICI)</option><option value={234}>TRINIDAD E TOBAGO</option>
                                            <option value={235}>TUNISIA</option><option value={236}>TURCHIA</option><option value={237}>TURKEMENISTAN</option><option value={238}>TURKS E CAICOS (ISOLE)</option><option value={239}>TUVALU</option><option value={240}>UCRAINA</option><option value={241}>UGANDA</option><option value={242}>UNGHERIA</option><option value={243}>URUGUAY</option><option value={244}>UZBEKISTAN</option><option value={245}>VANUATU</option><option value={246}>VENEZUELA</option>
                                            <option value={247}>ISOLE VERGINI AMERICANE</option><option value={248}>VIETNAM</option><option value={249}>VOLTA (ALTOVOLTA)</option><option value={250}>WALLIS E FUTUNA (ISOLE)</option><option value={251}>YEMEN</option><option value={252}>ZAMBIA</option><option value={253}>ZIMBABWE</option><option value={254}>Kosovo</option><option value={255}>SERBIA E MONTENEGRO</option><option value={256}>URSS - Unione Repubbliche Socialiste Sovietiche</option><option value={257}>SIERRA LEONE</option><option value={258}>APOLIDE</option><option value={259}>MONTENEGRO</option><option value={260}>TOGO</option><option value={261}>TERRITORI PALESTINESI</option><option value={263}>SERBIA</option>
                                        </select>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='comunenascita' label='Comune di nascita' />
                                </div>
                                <div className="col-sm">

                                    <Field component={InputField} id='provincianascita' label='provincia di nascita' />

                                </div>
                                <div className="col-sm">
                                    <div className="select-wrapper">
                                        <label htmlFor="cittadinanza">Cittadinanza</label>
                                        <select id="cittadinanza" onChange={event => formik.setFieldValue('cittadinanza', event.target.value)} >
                                            <option selected value="">Scegli un'opzione</option>
                                            <option value={122}>ITALIANA</option><option value={1}>AFGHANA</option><option value={2}>ALBANESE</option><option value={3}>ALGERINA</option><option value={4}>ANDORREGNA</option><option value={5}>ANGOLESE</option><option value={6}>INGLESE (ANGUILLA)</option><option value={7}>ANTIGUA E BARBUDA</option><option value={8}>ANTILLE BRITANNICHE</option><option value={9}>ANTILLESE</option><option value={10}>ARABA (ARABIA SAUDITA)</option><option value={11}>ARGENTINA</option><option value={12}>ARMENA</option><option value={13}>AUSTRALIANA</option><option value={14}>AUSTRIACA</option><option value={15}>AZBECA</option><option value={16}>BAHAMA</option><option value={17}>BAHREIN</option><option value={18}>BANGLADESE</option><option value={19}>BARBADOS</option><option value={20}>BELGA</option><option value={21}>BELIZE</option><option value={22}>BENINESE</option><option value={23}>BERMUDA (ISOLE)</option><option value={24}>BHUTAN</option><option value={25}>BIELORUSSA</option><option value={26}>BIRMANA</option><option value={27}>BOLIVIANA</option><option value={28}>BOSNIACA</option><option value={29}>BOTSWANA</option><option value={30}>BRASILIANA</option><option value={31}>BRUNEI</option><option value={32}>BULGARA</option><option value={33}>BURKINABE</option><option value={34}>BURUNDESE</option><option value={35}>CAMBOGIANA</option><option value={36}>CAMERUNENSE</option><option value={37}>CANADESE</option><option value={38}>CAPOVERDIANA</option><option value={39}>INGLESE (ISOLE CAYMAN)</option><option value={40}>CECOSLOVACCA</option><option value={41}>CENTRAFRICANA REPUBBLICA</option><option value={42}>AUSTRALIANA (ISOLA CHRISTMAS)</option><option value={43}>CHADIANA</option><option value={44}>CILENA</option><option value={45}>CINESE (REPUBBLICA POPOLARE CINESE)</option><option value={46}>CIPRIOTA</option><option value={47}>VATICANA</option><option value={48}>ISOLE COCOS (KEELING)</option><option value={49}>COLOMBIANA</option><option value={50}>COMORE</option>
                                            <option value={51}>ZAIRESE</option><option value={52}>CONGOLESE</option><option value={53}>COOK</option><option value={54}>COREANA (COREA DEL NORD)</option><option value={55}>COREANA (COREA DEL SUD)</option><option value={56}>IVORIANA</option><option value={57}>COSTA RICA</option><option value={58}>CROATA</option><option value={59}>CUBANA</option><option value={60}>DANESE</option><option value={61}>AUSTRALIANA (DIPENDENZE AUSTRALIANE)</option><option value={62}>INGLESE (DIPENDENZE BRITANNICHE)</option><option value={63}>CANADESE (DIPENDENZE CANADESI)</option><option value={64}>FRANCESE (DIPENDENZE FRANCESI)</option><option value={65}>NEOZELANDESE (DIPENDENZE NEOZELANDESI)</option><option value={66}>NORVEGESE (DIPENDENZE NORVEGESI ANTARTICHE)</option><option value={67}>NORVEGESE (DIPENDENZE NORVEGESI ARTICHE)</option><option value={68}>RUSSA (DIPENDENZE RUSSE)</option><option value={69}>AMERICANA (DIPENDENZE STATUNITENSI)</option><option value={70}>SUDAFRICANA (DIPENDENZE SUDAFRICANE)</option><option value={71}>DOMINICA</option><option value={72}>ECUADOREGNA</option><option value={73}>EGIZIANA</option><option value={74}>SALVADOREGNA</option><option value={75}>ARABA (EMIRATI ARABI UNITI)</option><option value={76}>ERITREA</option><option value={77}>ESTONE</option><option value={78}>ETIOPE</option><option value={79}>FAER OER (Isole)</option><option value={80}>FIGI O VITI</option><option value={81}>FILIPPINA</option><option value={82}>FINLANDESE</option><option value={83}>FRANCESE (FRANCIA)</option><option value={84}>GABONENSE</option><option value={85}>GAMBIANA</option><option value={86}>TERRITORI PALESTINESI (GAZA)</option><option value={87}>GEORGIANA</option><option value={88}>TEDESCA (GERMANIA)</option><option value={89}>TEDESCA (GERMANIA REPUBBLICA DEMOCRATICA)</option><option value={90}>TEDESCA (GERMANIA REPUBBLICA FEDERALE)</option><option value={91}>GANESE</option><option value={92}>GIAMAICANA</option><option value={93}>GIAPPONESE</option><option value={94}>INGLESE (GIBILTERRA)</option><option value={95}>GIBUTI</option><option value={96}>GIORDANA</option><option value={97}>INGLESE (GRAN BRETAGNA E IRLANDA DEL NORD)</option><option value={98}>GRECA</option><option value={99}>GRENADA</option><option value={100}>GROENLADESE</option><option value={101}>GUADALUPA</option>
                                            <option value={102}>GUAM (ISOLA)</option><option value={103}>GUATEMALTECA</option><option value={104}>GUIANA FRANCESE</option><option value={105}>GUINENSE (GUINEA)</option><option value={106}>GUINENSE (GUINEA BISSAU)</option><option value={107}>GUINENSE (GUINEA EQUATORIALE)</option><option value={108}>GUYANA</option><option value={109}>HAITIANA</option><option value={110}>ONDUREGNA</option><option value={111}>CINESE (HONG KONG)</option><option value={112}>INDIANA</option><option value={113}>INDONESIANA</option>
                                            <option value={114}>IRANIANA</option><option value={115}>IRACHENA</option><option value={116}>IRIANA</option><option value={117}>IRLANDESE</option><option value={118}>ISLANDESE</option><option value={119}>ISOLE CILENE (PASQUA E SALA Y GOMEZ)</option>
                                            <option value={120}>ISOLE VERGINI BRITANNICHE</option><option value={121}>ISRALIANO</option><option value={123}>IUGOSLAVA</option><option value={124}>KAZAKA</option><option value={125}>KENIOTA</option><option value={126}>KIRGIKA</option><option value={127}>KIRIBATI</option><option value={128}>KUWAITIANA</option><option value={129}>FRANCESE (ISOLA LA REUNION)</option><option value={130}>LOASSIANA</option><option value={131}>LESOTHO</option><option value={132}>LETTONE</option><option value={133}>LIBANESE (LIBANO)</option><option value={134}>LIBERIANA</option><option value={135}>LIBANESE (LIBIA)</option><option value={136}>LIECHTENSTEIN</option><option value={137}>LITUANA</option><option value={138}>LUSSEMBURGHESE</option><option value={139}>MACAONSE</option><option value={140}>MACEDONE</option><option value={141}>MACQUARIE (ISOLE)</option><option value={142}>MADAGASCAR</option><option value={143}>MALAWENSE</option><option value={144}>MALAISIANA</option><option value={145}>MALDIVIANA</option><option value={146}>MALIANA</option><option value={147}>MALTESE</option><option value={148}>MALVINE O FALKLAND (ISOLE)</option>
                                            <option value={149}>INGLESE (ISOLA MAN)</option><option value={150}>MARIANNE (ISOLE)</option><option value={151}>MAROCCHINA</option><option value={152}>AMERICANA (MARSHALL)</option><option value={153}>MARTINICA</option><option value={154}>MAURITANENSE</option><option value={155}>MAURITANA</option><option value={156}>FRANCESE (ISOLA MAYOTTE)</option><option value={157}>MESSICANA</option><option value={158}>MICRONESIANA</option><option value={159}>MIDWAY</option><option value={160}>MOLDAVA</option><option value={161}>MONAGHESCA</option><option value={162}>MONGOLA</option><option value={163}>INGLESE (MONTSERRAT)</option><option value={164}>MOZAMBICANA</option><option value={165}>NAMIBIANA</option><option value={166}>NAURU</option><option value={167}>NEPALESE</option><option value={168}>NICARAGUENSE</option><option value={169}>NIGER</option><option value={170}>NIGERIANA</option><option value={171}>NIUE O SAVAGE (ISOLE)</option><option value={172}>NORFOLK (ISOLE DEL MAR DEI CORALLI)</option><option value={173}>INGLESE (ISOLE NORMANNE)</option><option value={174}>NORVEGESE (NORVEGIA)</option><option value={175}>CALEDONE</option>
                                            <option value={176}>NEOZELANDESE (NUOVA ZELANDA)</option><option value={177}>OMAN</option><option value={178}>OLANDESE</option><option value={179}>PAKISTANA</option><option value={180}>PALAU</option><option value={181}>PANAMENSE (PANAMA)</option><option value={182}>PANAMENSE (PANAMA ZONA DEL CANALE)</option><option value={183}>PAPUA NUOVA GUINEA</option><option value={184}>PARAGUAIANA</option><option value={185}>PERUVIANA</option><option value={186}>PITCAIRN (E DIPENDENZE)</option><option value={187}>POLINESIANA</option><option value={188}>POLACCA</option><option value={189}>PORTOGHESE</option><option value={190}>PORTIRICANA</option><option value={191}>QATAR</option><option value={192}>CECA</option><option value={193}>REPUBBLICA DELLA GUAYANA</option><option value={194}>DOMINICANA</option><option value={195}>RUMENA</option><option value={196}>RUANDESE</option><option value={197}>RUSSA</option><option value={198}>SAINT KITTS E NEVIS</option><option value={199}>SANTA LUCIA</option><option value={200}>SAINT PIERRE ET MIQUELON</option><option value={201}>SAINT VINCENT E GRENADINE</option><option value={202}>SALOMONE</option><option value={203}>SAMOANA (SAMOA)</option><option value={204}>SAMOANA (ISOLE SAMOA AMERICANE)</option><option value={205}>SAN MARINESE</option><option value={206}>SANT'ELENA (ISOLA)</option><option value={207}>SAO TOME' E PRINCIPE</option><option value={208}>SEICELLE</option><option value={209}>SENEGALESE</option><option value={210}>SIERRA LEONE</option><option value={211}>SINGAPORE</option><option value={212}>SIRIANA</option><option value={213}>SLOVACCA</option><option value={214}>SLOVENA</option><option value={215}>SOMALA</option>
                                            <option value={216}>SPAGNOLA</option><option value={217}>CINGALESE</option><option value={218}>AMERICANA (STATI UNITI D'AMERICA)</option><option value={219}>STRANIERA</option><option value={220}>SUDAFRICANA (SUDAFRICANA REBUBBLICA)</option><option value={221}>SUDANESE</option><option value={222}>SURINAMENSE</option><option value={223}>SVEDESE</option><option value={224}>SVIZZERA</option><option value={225}>SWAZILAND</option><option value={226}>TAGIKA</option><option value={227}>TAIWANESE</option><option value={228}>TANZANESE</option><option value={229}>TAILANDESE</option><option value={230}>TIMORESE</option><option value={231}>TOGO</option><option value={232}>TOKELAU (ISOLE DELL'UNIONE)</option><option value={233}>TONGA (ISOLE DEGLI AMICI)</option><option value={234}>TRINIDAD E TOBAGO</option><option value={235}>TUNISINA</option><option value={236}>TURCA</option><option value={237}>TURKMENA</option><option value={238}>TURKS E CAICOS (ISOLE)</option><option value={239}>TUVALU</option><option value={240}>UCRAINA</option><option value={241}>UGANDESE</option><option value={242}>UNGHERESE</option><option value={243}>URUGUAIANA</option><option value={244}>UZBEKA</option><option value={245}>VANUATU</option><option value={246}>VENEZUELANA</option><option value={247}>ISOLE VERGINI AMERICANE</option><option value={248}>VIETNAMITA</option><option value={249}>VOLTA (ALTOVOLTA)</option><option value={250}>WALLIS E FUTUNA (ISOLE)</option><option value={251}>YEMENITA</option><option value={252}>ZAMBESE</option><option value={253}>ZIMBABWESE</option><option value={254}>KOSOVARA</option><option value={255}>SERBA</option><option value={256}>URSS - Unione Repubbliche Socialiste Sovietiche</option><option value={257}>SIERRALEONESE</option><option value={258}>APOLIDE</option><option value={259}>MONTENEGRINA</option><option value={260}>TOGOLESE</option><option value={261}>PALESTINESE</option><option value={263}>SERBA</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <br />

                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Dati Residenza / Domicilio</div></div>
                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} id='indirizzoresidenza' label='Residente nel Comune di - Via' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='civicoresidenza' label='Civico di residenza' />
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-sm">
                                    <Field component={InputField} id='indirizzodomicilio' label='Domicilio (se diverso dalla residenza)' />
                                </div>
                            </div>

                            <br />
                            {/**  <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Dati documento d'identità</div></div>

                            <div className="row">
                                <div className="col-sm">
                                    <div className="form-group">
                                        <div className="select-wrapper">
                                            <label htmlFor="tipodocumento">Tipo di documento</label>
                                            <select id="tipodocumento">
                                                <option selected value="">Scegli un'opzione</option>
                                                <option value={9}>Carta d'identità</option>
                                                <option value={10}>Carta Identita' Estera</option>
                                                <option value={12}>Doc.Ric.Ambasciate e Consolati Italiani</option>
                                                <option value={13}>Libretto Ciechi ed Invalidi</option>
                                                <option value={14}>Lib. Nominativo per Minorati Civili Mod. 4</option>
                                                <option value={15}>Lib. Pensioni INPS</option>
                                                <option value={16}>Patente di Guida</option>
                                                <option value={17}>Porto d'Armi</option>
                                                <option value={1}>Permesso di soggiorno estero superiore ad un anno</option>
                                                <option value={8}>Altro documento di soggiorno estero</option>
                                                <option value={7}>Permesso di soggiorno estero inferiore ad un anno</option>
                                                <option value={18}>Passaporto Estero</option>
                                                <option value={19}>Passaporto</option>
                                                <option value={20}>Tess. Dip. Statali Civili Militari</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='numerodocumento' label='Numero documento' />
                                </div>
                                <div className="col-sm">

                                    <div className="form-group">
                                        <div className="select-wrapper">
                                            <label htmlFor="entedocumento">Ente che ha rilasciato il documento</label>
                                            <select id="entedocumento">
                                                <option selected value="">Scegli un'opzione</option>
                                                <option value={1}>COMUNE</option>
                                                <option value={2}>AUTORITA'</option>
                                                <option value={3}>AUTORITA' CARCERARIA</option>
                                                <option value={4}>AMBASCIATA</option>
                                                <option value={5}>CONSOLATO</option>
                                                <option value={6}>MINISTERO</option>
                                                <option value={7}>REPUBBLICA</option>
                                                <option value={8}>STATO</option>
                                                <option value={9}>GOVERNO</option>
                                                <option value={10}>DIP.TRASPORTI TERRESTRI (EX MOTORIZZAZIONE)</option>
                                                <option value={11}>INPS</option>
                                                <option value={12}>PREFETTURA</option>
                                                <option value={13}>QUESTURA</option>
                                                <option value={14}>POLIZIA</option>
                                                <option value={15}>POLIZIA PENITENZIARIA</option>
                                                <option value={16}>COMMISSARIATO</option>
                                                <option value={17}>UFFICIO</option>
                                                <option value={18}>ENTE</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='comunedocumento' label='Comune presso il quale è stato rilasciato il documento' />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm">
                                    <Field component={InputField} classlabel='active' id='datarilascio' type='date' label='Data di rilascio del documento (gg/mm/aaaa)' />
                                </div>

                                <div className="col-sm">
                                    <Field component={InputField} classlabel='active' id='datascadenza' type='date' label='Data di scadenza del documento (gg/mm/aaaa)' />
                                </div>
                            </div>
                            <br />
                            */}
                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Recapiti</div></div>

                            <div className="row">
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label htmlFor='email'>e-mail</label>
                                        <input type="text" className="form-control" name='email' id='email' onChange={event => formik.setFieldValue('email', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='email' /> </small>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="form-group">
                                        <label htmlFor='confermaemail'>conferma e-mail</label>
                                        <input type="text" className="form-control" name='confermaemail' id='confermaemail' onChange={event => formik.setFieldValue('confermaemail', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='confermaemail' /> </small>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='telefono' label='telefono' />
                                </div>
                                <div className="col-sm">
                                    <Field component={InputField} id='cellulare' label='Cellulare' />
                                </div>
                            </div>


                            <br />
                            <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>CHIEDE L’AMMISSIONE AL
                                BENEFICIO:

                            </div></div>


                            <div>
                                <div className="form-check">

                                    <input id="intervento1" type="radio" name="intervento" onChange={event => formik.setFieldValue('intervento', event.target.checked)} />
                                    <label htmlFor="intervento1" >INTERVENTO 1- Sostegno e/o incremento al reddito - erogazione di contributi in
                                    denaro a favore di nuclei familiari in situazioni di particolare criticità per il
                                    raggiungimento del minimo reddituale (contributo una tantum);</label>
                                    <br />
                                    <input id="intervento2" type="radio" name="intervento" onChange={event => formik.setFieldValue('intervento', event.target.checked)} />
                                    <label htmlFor="intervento2" > INTERVENTO 2 – Sostegno e/o incremento al reddito erogazione di contributi in
                                    denaro a favore di nuclei familiari in situazioni di particolare criticità al cui interno sono
                                    presenti gestanti e/o minori da 0/3 anni, per il raggiungimento del minimo reddituale
                                    (contributo una tantum); </label>

                                </div>
                                <br />
                                <strong>In qualità di</strong>
                                <div className="form-check">

                                    <input id="genitore" type="radio" name="qualita" onChange={event => formik.setFieldValue('qualita', event.target.checked)} />
                                    <label htmlFor="genitore" > Genitore</label>
                                    <br />
                                    <input id="tutore" type="radio" name="qualita" onChange={event => formik.setFieldValue('qualita', event.target.checked)} />
                                    <label htmlFor="tutore" >Tutore </label>

                                </div>

                            </div>

                            <br />

                            {<>

                                <br />
                                <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>DICHIARA</div></div>

                                <p>Consapevole delle sanzioni penali previste in caso di dichiarazioni mendaci, falsità negli atti e uso di

                                    atti falsi (ART. 76 D.P.R. 445/28.12.2000)</p>


                                    
                                <div style={{display:'none'}} className="form-check">
                                    <p>   Che nessun altro componente del nucleo familiare ha presentato istanza di accesso al Fondo di
solidarietà alimentare (ordinanza n. 658 del 29.03.2020)</p>

                                    <input id="siistanzadoppia" type="radio" name="istanzadoppia" onChange={event => formik.setFieldValue('istanzadoppia', event.target.checked)} />
                                    <label htmlFor="siistanzadoppia" >SI</label>
                                    <br />
                                    <input id="noistanzadoppia" type="radio" name="istanzadoppia" onChange={event => formik.setFieldValue('istanzadoppia', event.target.checked)} />
                                    <label htmlFor="noistanzadoppia" >NO</label>


                                </div>

                               {  formik.getFieldProps('istanzadoppia') && <> 
                                                                                        
                                <div className="form-check">

                                    Che il nucleo familiare destinatario per cui si chiede il servizio è composto da n.   &nbsp;&nbsp;

                                    <select id="componenti">
                                        <option selected value="">Scegli un'opzione</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                        <option value={6}>6</option>
                                        <option value={7}>7</option>
                                        <option value={8}>8</option>
                                        <option value={9}>9</option>
                                        <option value={10}>10</option>
                                        <option value={11}>11</option>
                                        <option value={12}>12</option>
                                    </select>
                                    &nbsp;&nbsp;   componenti;




                                </div>

                                <div className="form-check">
                                    <p>Che nel nucleo è presente una gestante</p>

                                    <input id="sigestante" type="radio" name="" onChange={event => formik.setFieldValue('gestante', event.target.checked)} />
                                    <label htmlFor="sigestante" >SI</label>
                                    <br />
                                    <input id="nogestante" type="radio" name="gestamte" onChange={event => formik.setFieldValue('gestante', event.target.checked)} />
                                    <label htmlFor="nogestante" >NO</label>


                                </div>


                                <div className="form-check">

                                    Che il nucleo familiare destinatario per cui si chiede il servizio è composto da n.   &nbsp;&nbsp;

                                    <select id="figli">
                                        <option selected value="">Scegli un'opzione</option>
                                        <option value={0}>0</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                        <option value={6}>6</option>
                                        <option value={7}>7</option>
                                        <option value={8}>8</option>
                                        <option value={9}>9</option>
                                        <option value={10}>10</option>
                                        <option value={11}>11</option>
                                        <option value={12}>12</option>
                                    </select>
                                    &nbsp;&nbsp;   figli
                                    maggiorenni a carico;




                                </div>

                                <div className="form-check">

                                    Che all’interno del nucleo vi sono n.   &nbsp;&nbsp;

                                    <select id="minori">
                                        <option selected value="">Scegli un'opzione</option>
                                        <option value={0}>0</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                        <option value={6}>6</option>
                                        <option value={7}>7</option>
                                        <option value={8}>8</option>
                                        <option value={9}>9</option>
                                        <option value={10}>10</option>
                                        <option value={11}>11</option>
                                        <option value={12}>12</option>
                                    </select>
                                    &nbsp;&nbsp;   minori;




                                </div>

                                <div className="form-check">
                                    Che all’interno del nucleo vi sono n.   &nbsp;&nbsp;
                                    <select id="minori03">
                                        <option selected value="">Scegli un'opzione</option>
                                        <option value={0}>0</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                        <option value={6}>6</option>
                                        <option value={7}>7</option>
                                        <option value={8}>8</option>
                                        <option value={9}>9</option>
                                        <option value={10}>10</option>
                                        <option value={11}>11</option>
                                        <option value={12}>12</option>
                                    </select>
                                    &nbsp;&nbsp;   minori 0-3 anni;
                                </div>
                                <br/>
                                <strong>Che la condizione lavorativa del nucleo familiare è la seguente:</strong>
                                <br/>
                                <div className="form-check">
                                Indicare il numero di componenti occupati del nucleo: n.   &nbsp;&nbsp;
                                    <select id="occupatinucleo">
                                        <option selected value="">Scegli un'opzione</option>
                                        <option value={0}>0</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                        <option value={6}>6</option>
                                        <option value={7}>7</option>
                                        <option value={8}>8</option>
                                        <option value={9}>9</option>
                                        <option value={10}>10</option>
                                        <option value={11}>11</option>
                                        <option value={12}>12</option>
                                    </select>
                                    &nbsp;&nbsp; ;
                                </div>

                                <div className="form-check">
                                Genitore (o facente funzione) disoccupato da meno di 1 anno dalla data di pubblicazione del bando
n.  &nbsp;&nbsp;
                                    <select id="disoccupatonucleo">
                                        <option selected value="">Scegli un'opzione</option>
                                        <option value={0}>0</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                  
                                    </select>
                                    &nbsp;&nbsp; ;
                                </div>

                                <div className="form-check">
                                
                                Genitore (o facente funzione) disoccupato da oltre 1 anno dalla data di pubblicazione del bando n.  &nbsp;&nbsp;
                                    <select id="disoccupatonucleoanno">
                                        <option selected value="">Scegli un'opzione</option>
                                        <option value={0}>0</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                    
                                    </select>
                                    &nbsp;&nbsp; ;
                                </div>
                             
                                <div className="form-check">
                                Che il valore dell’Isee è pari a: €   &nbsp; <input style={{width:200}} type="number" className="form-control" name='valoreisee' id='valoreisee' onChange={event => formik.setFieldValue('valoreisee', event.target.value)} />
                                        <small className="error">  <ErrorMessage name='valoreisee' /> </small>
                                    
                                
                                </div>


                                <br />
                                <div className="form-group"><div className="col-sm-12 text-center white bg-primary" style={{ color: 'white' }}>Allega</div></div>

                                <div className="form-upload" style={{ padding: 20 }}>
                                    <label style={{ textOverflow: 'unset', whiteSpace: 'unset', lineHeight: 'inherit' }} htmlFor="documento" className="active">
                                    Fotocopia di un documento di identità in corso di validità del richiedente;
                                    </label>
                                    <input type="file" name="documento" id="documento" required className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-1"
                                        onChange={e => formik.setFieldValue(`allegati.${0}.documento`, e.target.files[0])}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.documento`} /></small>

                                </div>

                                <div className="form-upload" style={{ padding: 20 }}>
                                    <p className="active">Attestazione ISEE in corso di validità; </p>
                                    <input type="file" name="fileisee" id="fileisee" className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-6" style={{}}

                                        onChange={e => (formik.setFieldValue(`allegati.${0}.fileisee`, e.target.files[0]))}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.fileisee`} /></small>
                                </div>
                         
                                <div className="form-upload" style={{ padding: 20 }}>
                                    <label htmlFor="altro" className="active">
                                        
                                    <a  target='_blank' href="Allegato-2.docx"  >Allegato 2</a>
                                    -  Attestazione copia Iban rilasciato dall’istituto di credito (Postale e/o bancario) <a  target='_blank' href="Allegato-2.docx"  >link file da compilare</a>;  
                                        
                                        </label>
                                    <input type="file" name="altro" id="altro" className="is-invalid" data-focus-mouse="false" aria-invalid="true" aria-describedby="upload-error-6" style={{}}

                                        onChange={e => (formik.setFieldValue(`allegati.${0}.altro`, e.target.files[0]))}
                                    />
                                    <small className="error"><ErrorMessage name={`allegati.${0}.altro`} /></small>

                                </div>


                                <div style={{ display: 'none' }} id='spinner' className="progress progress-indeterminate">
                                    <span className="visually-hidden">In elaborazione...</span>
                                    <div className="progress-bar" role="progressbar" />
                                </div>
                                <hr />
                                <div className="form-group">
                                    <div className="btn-group col-sm-5 col-sm-offset-6 ">
                                        <button name="_anteprima" id="_anteprima" value="true" type="button" className="btn btn-primary btn-md pull-left" style={{ width: 150, display: 'none' }}

                                            onClick={() => {
                                                stampa_id('root');
                                                console.log(formik.errors);
                                            }}

                                        >Anteprima</button>
                                        {/**   <button name="_stampadomanda" id="_stampadomanda" value="true" type="button" className="btn btn-primary btn-md pull-left" style={{ width: 150 }}>Stampa domanda</button>
                                   */}  <button name="_conferma" id="_conferma" value="true" type="button" className="btn btn-primary btn-md pull-left" style={{ width: 150 }} onClick={() => {

                                            // alert('invio');

                                            formik.validateForm().then(async res => {
                                                const { ob } = await res;

                                                let b = Object.keys(res).length;


                                                //       console.log('res', b, res);

                                                //     console.log(b);

                                        

                                                if (res.allegati !== undefined) {
                                                    b = b - 1;
                                                    // @ts-ignore 
                                                    b += Object.keys(res.allegati[0]).length;

                                                }

                                                console.log(b);


                                                if (b > 0) {
                                                    Toast.fire({
                                                        title: 'ci sono ' + b + ' Errori nella compilazione',
                                                        icon: 'error'
                                                    });
                                                } else {
                                                    document.getElementById('spinner').style.display = 'inline';
                                                    document.getElementById('_conferma').style.display = 'none';

                                                }


                                            });

                                            console.log(formik.errors);

                                            formik.submitForm();

                                        }}>Invia</button></div>


                                </div>
                                </>}
                            </>
                            }
                        </div>}
                    </div>)}
            </Formik >
            </>}


        </>
    )
}

export default Domanda;